import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledHeaderButton } from '../Header/styles';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { removePages } from '../../../containers/Editor/actions';

interface ButtonRemovePageProps {
	isDisabled: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonRemovePage = ({ isDisabled, dispatch }: ButtonRemovePageProps) => (
	<StyledHeaderButton
		width="23px"
		height="23px"
		disabled={isDisabled}
		onClick={() => dispatch(removePages())}
	>
		{Utils.getSvgIcon('iconset_uprez_trash')}
	</StyledHeaderButton>
);

export default ButtonRemovePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonRemovePage/index.tsx